<article [ngClass]="isFromSizeOfPrize ? 'sizeOfPrizeComparison' : ''">
  <mpro-loading *ngIf="isLoading"></mpro-loading>
  <div *ngIf="!isFromSizeOfPrize">
    <div class="header">Region Comparison</div>
    <mpro-tags style="margin: 8px 0px"></mpro-tags>
    <hr />
  </div>
  <div class="header" *ngIf="isFromSizeOfPrize">
    <h2>Spending Ranking</h2>
    <h3>
      {{ dataFilters.regionSelection.getName() }} - {{ dataFilters.year }}
    </h3>
    <mpro-tags style="margin: 15px 0px"></mpro-tags>
  </div>

  <mpro-region-comparison-table
    [isFromSizeOfPrize]="isFromSizeOfPrize"
    [currency]="currency"
    [selected]="selectedCode"
    (selectedChanged)="updateCurrentlySelectedCountries($event)"
    [countries]="tableData"
    (sortChanged)="sortChanged($event)"
    [selectedYear]="dataFilters.year"
  >
  </mpro-region-comparison-table>

  <hr *ngIf="!isFromSizeOfPrize" />

  <mpro-region-comparison-chart
    *ngIf="!isFromSizeOfPrize && isCategoriesEnabled"
    [isCategories]="isCategoriesEnabled"
    [selected]="selectedName"
    [selectedYear]="dataFilters.year"
    [chartData]="chartData"
    (chartDataFiltersChanged)="updateChartDataFilters($event)"
  >
  </mpro-region-comparison-chart>
  <mpro-region-comparison-chart
    *ngIf="!isFromSizeOfPrize && !isCategoriesEnabled && dataFilters.currency===1"
    [isCategories]="isCategoriesEnabled"
    [currency]="1"
    [selected]="selectedName"
    [selectedYear]="dataFilters.year"
    [chartData]="chartData"
    (chartDataFiltersChanged)="updateChartDataFilters($event)"
  >
  </mpro-region-comparison-chart>
  <mpro-region-comparison-chart
    *ngIf="!isFromSizeOfPrize && !isCategoriesEnabled && dataFilters.currency!==1"
    [isCategories]="isCategoriesEnabled"
    [currency]="0"
    [selected]="selectedName"
    [selectedYear]="dataFilters.year"
    [chartData]="chartData"
    (chartDataFiltersChanged)="updateChartDataFilters($event)"
  >
  </mpro-region-comparison-chart>
</article>
